// Panel Auto-Refresh — client tuning constants (web panel only, never the mobile apps).
//
// The refresh *schedule itself* is not defined here. It is owned by the Node backend
// (config/refreshSchedule.json) and delivered by GET /get-panel-refresh-schedule, so
// the times can be changed on the server without rebuilding this app.

export const REFRESH_STORAGE_KEYS = {
  // The refresh boundary this tab's data is currently known to be fresh for.
  // Shared by all three trigger paths (upcoming window, missed window, manual event)
  // so a reload can never re-arm the banner it just dismissed.
  SEEN_WINDOW: "lvb_seen_refresh_window",
  // Id of the manual "force refresh everyone" event this tab has already acted on.
  SEEN_MANUAL: "lvb_seen_manual_refresh",
  // Safety net: written just before window.location.reload(). Blocks any possibility
  // of a reload loop if the window logic ever disagrees with itself.
  RELOAD_LOCK: "lvb_refresh_reload_lock"
};

export const REFRESH_POLL_INTERVAL_MS = 15000;
export const REFRESH_TICK_INTERVAL_MS = 1000;

// Ignore a stored lock that is older than this. A slow reload on a poor connection
// must not leave the tab permanently unable to refresh again.
export const REFRESH_RELOAD_LOCK_MS = 60000;
